import '../../style/index.css';
import './index.css';

// style dependencies
// deps-lint-skip: tooltip